import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";

import Emitter from "utility/emitter";
import ConfirmationDialog from "components/ConfirmationDialog";
import { Shared } from "utility/shared";
import { RootState } from "redux/store";
import { AppRoutings } from "utility/enums/app-routings";
import { OPEN_SESSION_EXPIRE_DIALOG } from "utility/emitterEvents";
import { UserType } from "utility/enums/user-type";
import { LoginUserDetail } from "models/LoginUserDetail";
import { setLoggedInUserDetail } from "redux/authStateSlice";

export const ExternalUserSessionExpireHandler: React.FC = () => {
	let navigate = useNavigate();
	const dispatch = useDispatch();
	const userDetails = useSelector(
		(state: RootState) => state.authState.userDetails
	);

	const [sessionExpireTimer, setSessionExpireTimer] = useState<
		NodeJS.Timer | any
	>(0);
	const [openDialog, setOpenDialog] = React.useState<boolean>(false);

	useEffect(() => {
		if (userDetails && userDetails.userTypeId === UserType.External) {
			clearInterval(sessionExpireTimer);
			startTimer();
			localStorage.setItem(
				Shared.localStorageKeys.isExternalUserLoggedIn,
				"true"
			);
		} else {
			clearInterval(sessionExpireTimer);
		}
		return () => {
			clearInterval(sessionExpireTimer);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userDetails.userTypeId]);

	const startTimer = () => {
		setSessionExpireTimer(
			setInterval(() => {
				const isExternalUserLoggedIn = localStorage.getItem(
					Shared.localStorageKeys.isExternalUserLoggedIn
				);
				if (isExternalUserLoggedIn === "false") {
					if (openDialog) setOpenDialog(false);
					clearInterval(sessionExpireTimer);
					localStorage.removeItem(
						Shared.localStorageKeys.isExternalUserLoggedIn
					);
					navigate(AppRoutings.SignIn);
				}
			}, 1000)
		);
	};

	const handleConfirmationDialogClose = () => {
		setOpenDialog(false);
		dispatch(setLoggedInUserDetail({} as LoginUserDetail));
		Shared.clearStorageValues();
		localStorage.setItem(
			Shared.localStorageKeys.isExternalUserLoggedIn,
			"false"
		);
	};

	useEffect(() => {
		Emitter.on(OPEN_SESSION_EXPIRE_DIALOG, () => {
			setOpenDialog(true);
		});
		return () => {
			Emitter.off(OPEN_SESSION_EXPIRE_DIALOG, undefined);
		};
	}, []);

	return openDialog ? (
		<ConfirmationDialog
			open={openDialog}
			title="Session Expired"
			message="The current session is expired! To return to the login screen, click the ok button."
			showTitleCloseIcon={false}
			showActionButtons={false}
			dialogActionContent={
				<Button variant="contained" onClick={handleConfirmationDialogClose}>
					OK
				</Button>
			}
			handleDialogClose={() => {}}
		/>
	) : (
		<></>
	);
};
